import axios from '../axios'

export const getGrowthPointList = (data) => {
  return axios({
    url: '/applet/mind/wxPointsRank',
    method: 'GET',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/growthPoint.js